import clsx from "clsx"

import { ForwardedRef, type FC } from "react"

import style from "./style.module.scss"

type Props = {
  type?: string
  className?: string
  label?: string
  value?: string | number
  placeholder?: string
  ref?: ForwardedRef<unknown> | null

  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

const Input: FC<Props> = ({ type, className, label, value, placeholder, onChange, ref, onKeyDown }) => {
  return (
    <fieldset className={style.inputWrapper}>
      {label && <legend>{label}</legend>}
      <input
        type={type}
        className={clsx(style.input, { [style.search]: type === "search" }, className)}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
    </fieldset>
  )
}

export default Input
